module.exports = {
    ROUTER_BASEURL:"/",//路由根目录baseUrl,
    BASE_URL:"/",//发布BaseUrl
}
